import { CrossDock, ForceDispatchCrossDockResponse } from './crossDockTrackingTypes';

export const mockGetCrossDocks: CrossDock[] = [{
  address: {
    id: 1,
    addressLine1: 'ul. Św. Antoniego',
    city: 'Praha',
    country: 'CZ',
    email: 'info@mall.cz',
    name: 'Josef Novák',
    phone: '+420701000001',
    zip: '17001',
  },
  code: 'OLZA-1',
},
{
  address: {
    id: 2,
    addressLine1: 'U garáží 1',
    city: 'Wroclaw',
    country: 'PL',
    email: 'info@mall.pl',
    name: 'Józef Nowak',
    phone: '+48123456789',
    zip: '50-155',
  },
  code: 'OLZA-2',
}];

export const mockForceDispatchCrossDock: ForceDispatchCrossDockResponse = {
  orders: [{
    orderIds: [1],
    status: 'CREATED',
    xdockProviderId: 'OLZA-1',
    message: null,
  },
  {
    orderIds: [2, 3],
    status: 'CREATE_FAILED',
    xdockProviderId: null,
    message: 'Cross-dock order could not be created in OLZA for orders with ids ([2, 3]).',
  },
  {
    orderIds: [4],
    status: 'SKIPPED',
    xdockProviderId: null,
    message: 'Order with id (4) was not ready for the cross-dock.',
  }],
};
